import { TranslationType } from '../types';

export const id: TranslationType = {
  common: {
    wallets: 'Dompet',
    dashboard: 'Dasbor',
    settings: 'Pengaturan',
    darkMode: 'Mode Gelap',
    lightMode: 'Mode Terang',
    language: 'Bahasa',
    english: 'English',
    chinese: '中文',
    russian: 'Русский',
    german: 'Deutsch',
    indonesian: 'Bahasa Indonesia',
    korean: '한국어',
    japanese: '日本語',
    thai: 'ภาษาไทย',
    blog: 'Blog'
  },
  footer: {
    quickLinks: 'Tautan Cepat',
    about: 'Tentang Kami',
    terms: 'Ketentuan Layanan',
    privacy: 'Kebijakan Privasi',
    contact: 'Hubungi Kami',
    copyright: '© 2025 XCH.live. Hak Cipta Dilindungi.',
    description: 'Platform pemantauan tingkat lanjut untuk dompet blockchain Chia. Dapatkan notifikasi transaksi real-time, lindungi aset Anda dengan pemberitahuan instan, dan pantau aktivitas dompet dingin.',
    connectWithUs: 'Hubungi Kami',
    builtBy: 'Dibuat dengan ❤️ oleh tim Spacescan.io'
  },
  home: {
    hero: {
      title: 'Pantau Dompet Dingin Chia Anda',
      subtitle: 'Dapatkan notifikasi email instan untuk transaksi XCH',
      input: {
        label: 'Masukkan kunci utama (96 karakter) atau alamat XCH',
        placeholder: 'Masukkan kunci utama (96 karakter) atau alamat XCH',
        helper: 'Masukkan kunci utama atau alamat XCH Anda untuk mulai memantau'
      },
      buttons: {
        cardprefix: '$12',
        card: 'Bayar dengan Kartu',
        strprefix: '50% OFF',
        str: 'Bayar dengan STR'
      }
    },
    features: {
      title: 'Lindungi Chia Anda Sebelum Terlambat',
      subtitle: 'Jangan tunggu peretas - lindungi dompet dingin Anda secara proaktif dengan pemantauan 24/7',
      vault: {
        title: 'Aktifkan Vault dan Clawback',
        description: 'Lindungi aset Anda dengan fitur brankas dan penarikan kembali tingkat lanjut'
      },
      monitoring: {
        title: 'Pemantauan Aman',
        description: 'Lacak aktivitas dompet dingin tanpa mengungkapkan kunci pribadi'
      },
      alerts: {
        title: 'Notifikasi Instan',
        description: 'Terima notifikasi email instan untuk semua transaksi'
      },
      recovery: {
        title: 'Pemulihan Dana',
        description: 'Pulihkan dana dari transaksi yang tidak sah selama periode penarikan kembali'
      }
    },
    metrics: {
      title: 'Dampak Kami dalam Angka',
      walletsMonitored: {
        label: 'Dompet Dipantau'
      },
      alertsSent: {
        label: 'Notifikasi Terkirim'
      },
      transactionsAnalyzed: {
        label: 'Transaksi Dianalisis'
      }
    },
    testimonials: {
      title: 'Apa Kata Pengguna Kami',
      items: [
        {
          quote: 'XCH.live memberi saya ketenangan pikiran mengetahui dompet dingin saya dipantau 24/7. Notifikasi instan benar-benar mengubah permainan.',
          author: 'Michael Chen',
          role: 'Petani Chia'
        },
        {
          quote: 'Penyiapannya sangat mudah dan pemantauannya dapat diandalkan. Tepat seperti yang saya butuhkan untuk aset Chia saya.',
          author: 'Sarah Johnson',
          role: 'Investor Kripto'
        },
        {
          quote: 'Solusi terbaik untuk memantau dompet Chia. Notifikasi email cepat dan dasbornya sangat intuitif.',
          author: 'David Kim',
          role: 'Pengembang Blockchain'
        }
      ]
    }
  },
  settings: {
    title: 'Pengaturan',
    subtitle: 'Kelola pengaturan dompet',
    notifications: {
      title: 'Notifikasi',
      emailNotifications: 'Notifikasi Email',
      emailDescription: 'Terima pembaruan transaksi melalui email',
      threshold: {
        title: 'Ambang Transaksi',
        description: 'Jumlah XCH minimum untuk mengirim notifikasi (minimum 1 XCH)'
      }
    },
    walletInfo: {
      title: 'Informasi Dompet',
      masterKey: 'Kunci Utama'
    },
    actions: {
      save: 'Simpan Perubahan',
      delete: 'Hapus Dompet'
    },
    messages: {
      success: 'Pengaturan berhasil disimpan!',
      error: {
        generic: 'Tidak dapat memperbarui pengaturan',
        threshold: 'Ambang harus lebih besar dari atau sama dengan 1 XCH',
        delete: 'Tidak dapat menghapus dompet'
      },
      deleteConfirm: 'Anda yakin ingin menghapus dompet ini? Tindakan ini tidak dapat dibatalkan.'
    }
  },
  wallets: {
    title: 'Dompet Saya',
    subtitle: 'Kelola dan pantau dompet dingin Anda',
    status: {
      active: 'Pemantauan Aktif',
      pending: 'Menunggu Pembayaran',
      expired: 'Pemantauan Kedaluwarsa',
      timeLeft: {
        days: 'Sisa {{days}}h {{hours}}j',
        hours: 'Sisa {{hours}}j {{minutes}}m',
        minutes: 'Sisa {{minutes}}m',
        lessThanMinute: 'Sisa kurang dari 1m'
      }
    },
    actions: {
      payWithCard: 'Bayar dengan Kartu',
      completeCryptoPayment: 'Selesaikan Pembayaran Kripto',
      renewMonitoring: 'Perbarui Pemantauan',
      dashboard: 'Dasbor',
      settings: 'Pengaturan',
      addFirstWallet: 'Tambah Dompet Pertama',
      removeWallet: 'Hapus Dompet'
    },
    messages: {
      noWallets: 'Tidak ada dompet ditemukan'
    }
  },
  dashboard: {
    title: 'Dasbor Dompet',
    tabs: {
      events: 'Peristiwa',
      addresses: 'Alamat'
    },
    addresses: {
      totalAddresses: 'Total Alamat: {{count}}',
      index: 'Indeks',
      address: 'Alamat',
      actions: 'Tindakan'
    },
    events: {
      loadMore: 'Muat Lebih Banyak',
      noEvents: 'Tidak ada peristiwa ditemukan',
      sent: 'Terkirim',
      received: 'Diterima',
      spent: 'Digunakan',
      pending: 'Tertunda',
      failed: 'Gagal',
      showDetails: 'Tampilkan Detail',
      hideDetails: 'Sembunyikan Detail',
      block: 'Blok',
      viewOnSpacescan: 'Lihat di Spacescan',
      transactionHash: 'Hash Transaksi',
      nftsReceived: 'NFT Diterima',
      nftsSent: 'NFT Terkirim',
      nftTransaction: 'Transaksi NFT',
      viewNFTDetails: 'Lihat Detail NFT',
      receivedNFTs: 'NFT yang Diterima',
      sentNFTs: 'NFT yang Terkirim'
    }
  },
  faq: {
    title: 'Pertanyaan Umum',
    security: {
      question: 'Seberapa aman layanan pemantauan Anda?',
      answer: 'Layanan kami beroperasi dengan standar keamanan tertinggi, hanya menggunakan kunci utama publik Anda untuk tujuan pemantauan. Dana Anda sepenuhnya aman karena kami tidak pernah memiliki akses ke kunci pribadi atau kemampuan pengeluaran. Kami menggunakan standar kriptografi BLS-12-381, di mana kunci pribadi (32 byte) dan kunci publik (48 byte) tetap terpisah dan aman.',
      learnMore: 'Pelajari lebih lanjut tentang kunci BLS di Chia →'
    },
    monitoring: {
      question: 'Seberapa sering transaksi dipantau?',
      answer: 'Sistem kami memantau transaksi secara real-time, memeriksa setiap blok baru di blockchain Chia. Kami melacak aktivitas di semua alamat yang dipantau, memberikan notifikasi instan untuk setiap transaksi yang mempengaruhi dompet Anda.'
    },
    masterKey: {
      question: 'Bagaimana cara menemukan kunci utama publik dompet saya?',
      answer: 'Anda dapat mengakses kunci utama publik Anda melalui dompet Chia GUI atau CLI. Kami telah menyiapkan tutorial video terperinci yang akan memandu Anda melalui proses ini. Penting: jangan pernah bagikan kunci pribadi atau frasa benih Anda - layanan pemantauan kami hanya membutuhkan kunci utama publik.',
      videoTitle: 'Cara menemukan kunci utama publik Anda',
      learnMore: 'Baca panduan terperinci tentang menemukan kunci →'
    },
    addresses: {
      question: 'Berapa banyak alamat yang dipantau dengan kunci utama saya?',
      answer: 'Layanan kami memantau 100 alamat turunan yang terkait dengan kunci utama Anda, memberikan cakupan lengkap aktivitas transaksi dompet Anda.'
    },
    singleAddress: {
      question: 'Bisakah saya memantau alamat tertentu alih-alih menggunakan kunci utama?',
      answer: 'Ya, layanan kami menawarkan fleksibilitas dalam pemantauan alamat individual. Anda dapat memilih untuk memantau satu alamat tertentu alih-alih menggunakan kunci utama untuk memantau beberapa alamat.'
    },
    notifications: {
      question: 'Bagaimana cara mengatur notifikasi saya?',
      answer: 'Anda memiliki kendali penuh atas notifikasi email Anda melalui pengaturan dompet. Dasbor kami menyediakan opsi untuk menyesuaikan preferensi notifikasi sesuai dengan kebutuhan pemantauan Anda.'
    },
    vault: {
      question: 'Apa itu Chia vault dan bagaimana cara kerjanya?',
      answer: 'Chia vault adalah fitur keamanan tingkat lanjut yang memberikan perlindungan yang ditingkatkan untuk aset digital Anda. Ini menerapkan tindakan keamanan tambahan seperti persyaratan multi-sig atau transaksi dengan penundaan waktu. Brankas memisahkan penyimpanan aset dari koin dan dapat memerlukan beberapa tanda tangan (multi-sig m-of-n) untuk persetujuan transaksi.',
      learnMore: 'Pelajari lebih lanjut tentang Chia Vaults →'
    },
    clawback: {
      question: 'Apa itu fitur clawback di Chia?',
      answer: 'Clawback adalah fitur keamanan di Chia yang memungkinkan pembatalan transaksi dalam periode waktu tertentu. Saat diaktifkan, penerima harus menunggu sampai periode penarikan kembali berakhir sebelum dapat mengakses dana yang ditransfer, memberikan lapisan keamanan tambahan untuk transaksi.'
    },
    vaultSupport: {
      question: 'Apakah layanan Anda mendukung fitur vault dan clawback?',
      answer: 'Meskipun kami memantau transaksi yang menggunakan vault dan clawback, kami tidak mengelola fitur-fitur ini secara langsung. Fitur-fitur ini harus diatur saat pembuatan dompet. Layanan kami berfokus pada pemantauan transaksi dan pengiriman notifikasi untuk alamat Anda.'
    },
    tokens: {
      question: 'Apakah Anda menyediakan pemantauan untuk token Chia?',
      answer: 'Saat ini, layanan pemantauan kami berfokus secara eksklusif pada transaksi XCH. Fungsionalitas pemantauan token tidak termasuk dalam penawaran layanan kami saat ini.'
    },
    nft: {
      question: 'Apakah pemantauan transaksi NFT tersedia?',
      answer: 'Saat ini, layanan kami mengkhususkan diri dalam pemantauan transaksi XCH. Pemantauan transaksi NFT tidak termasuk dalam kemampuan layanan saat ini.'
    },
    subscription: {
      question: 'Bagaimana kebijakan berlangganan dan pengembalian dana Anda?',
      answer: 'Layanan kami disediakan berdasarkan langganan. Karena sifat instan dari layanan pemantauan kami, kami tidak memberikan pengembalian dana setelah layanan diaktifkan. Harap pastikan Anda memahami ketentuan layanan kami sebelum berlangganan.'
    }
  },
  notFound: {
    title: 'Halaman Tidak Ditemukan',
    lostMessage: 'Jangan biarkan Chia Anda seperti halaman ini - hilang dalam kehampaan!',
    securityMessage: 'Kembali ke beranda dan temukan cara mengamankan & memantau XCH Anda 24/7.',
    protectButton: 'Lindungi Chia Anda'
  }
}; 